// Шрифт Inter self-hosted: латиница и вьетнамский — интерфейс живёт на трёх
// локалях, и подгружать шрифт со стороннего CDN на рабочем инструменте незачем.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'

import '@vinprop/design-system/styles.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setupTheme } from '@vinprop/design-system'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'

// Тему ведёт пакет: атрибут data-theme и подписка на системную при AUTO.
// Хранение — отдельный ключ трекера, чтобы не делить localStorage с CRM.
setupTheme({
  initial: (localStorage.getItem('tracker-theme') as 'light' | 'dark' | 'auto' | null) ?? 'auto',
  persist: (theme) => localStorage.setItem('tracker-theme', theme),
})

createApp(App).use(createPinia()).use(router).use(i18n).mount('#app')
